import { render, staticRenderFns } from "./pay_config.vue?vue&type=template&id=c56fc1ce&scoped=true"
import script from "./pay_config.vue?vue&type=script&lang=ts"
export * from "./pay_config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56fc1ce",
  null
  
)

export default component.exports